import _ from 'lodash';
import ViewModelUtil from 'gw-portals-viewmodel-js/ViewModelUtil';

class AdditionalInterestsCtrl {

    constructor($filter, ViewModelService, ModalService, LocaleService) {
        this.viewModelService = ViewModelService;
        this.filter = $filter;
        this.modalService = ModalService;

        this.phoneMask = LocaleService.getRegionSamplePhoneNumber().replace(/[0-8]/g, '9');
    }

    $onInit() {
        this.additionalInterests = this.model;
        this.translatedLabel = this.filter('translate')(this.label) || this.filter('translate')('quoteandbind.views.ho-your-home.additional-interest.Additional Interests');
    }

    addAdditionalInterest() {
        const initialValue = {
            policyAdditionalInterest: {
                subtype: 'Person',
                primaryAddress: {}
            }
        };

        const rootViewModel = ViewModelUtil.findRoot(this.model);

        const initialContext = {
            AdditionalInterestType: _.get(rootViewModel, this.additionalinterestTypePath)
        };

        const currentAdditionalInterest =
            this.viewModelService.create(
                initialValue, 'pc',
                'edge.capabilities.policyjob.lob.AdditionalInterestDTO',
                initialContext
            );
        
        this.additionalInterests.pushElement(currentAdditionalInterest);
    }

    removeAdditionalInterest(indexToRemove) {
        const msg = {
            key: 'quoteandbind.views.ho-your-home.additional-interest.AddIntRemovalMsg'
        };

        this.modalService.showWarning(
            'quoteandbind.views.ho-your-home.additional-interest.Remove Additional Interest?', msg, '',
            this.filter('translate')('quoteandbind.views.ho-your-home.additional-interest.Yes'), 'gw-btn-primary',
            this.filter('translate')('quoteandbind.views.ho-your-home.additional-interest.No')
        )
            .result.then(() => {
                this.additionalInterests.value =
                    this.additionalInterests.value.filter((_element, index) => {
                        return index !== indexToRemove;
                    });
            });
    }
}

AdditionalInterestsCtrl.$inject = ['$filter', 'ViewModelService', 'ModalService', 'LocaleService'];

export default AdditionalInterestsCtrl;    